import React from 'react';
import { Navigate } from 'react-router-dom';
import { useLogin } from './LoginContext'; // นำเข้าจาก LoginContext ที่สร้างไว้

const RequireAuth = ({ children }) => {
    const { isLoggedIn } = useLogin(); // ดึงสถานะการล็อกอิน

    // ถ้าไม่ได้ล็อกอิน จะนำทางไปที่หน้า login
    if (!isLoggedIn) {
        return <Navigate to="/Checklogin/NotLogin" />; // เปลี่ยนไปหน้า login
    }

    // ถ้าล็อกอินแล้ว ให้แสดงหน้าที่ต้องการ
    return children;
};

export default RequireAuth;
